import React from 'react';
import { Descriptions } from 'antd';
import { useAuth } from '../../hooks/useAuth';
import { FormattedMessage } from 'react-intl';
import { Card } from '../../components/MarketerView/atoms';
import { THEME } from '../../components/MarketerView/config/theme';
import { AgencyEyebrow, AgencyPageHeader } from '../components/agencyUi';

export const AgencySettingsPage: React.FC = () => {
    const { user } = useAuth();

    return (
        <div>
            <AgencyPageHeader
                title={
                    <FormattedMessage id="agency.settings.title" defaultMessage="Agency Settings" />
                }
            />

            <Card style={{ marginBottom: 16, maxWidth: 720 }}>
                <AgencyEyebrow>
                    <FormattedMessage
                        id="agency.settings.agencyInfo"
                        defaultMessage="Agency Information"
                    />
                </AgencyEyebrow>
                <Descriptions column={1} bordered size="small">
                    <Descriptions.Item
                        label={
                            <FormattedMessage
                                id="agency.settings.name"
                                defaultMessage="Agency Name"
                            />
                        }
                    >
                        {user?.organisation?.name || '-'}
                    </Descriptions.Item>
                    <Descriptions.Item
                        label={
                            <FormattedMessage
                                id="agency.settings.orgId"
                                defaultMessage="Organisation ID"
                            />
                        }
                    >
                        {user?.organisation?.id || '-'}
                    </Descriptions.Item>
                </Descriptions>
            </Card>

            <Card style={{ maxWidth: 720 }}>
                <AgencyEyebrow>
                    <FormattedMessage
                        id="agency.settings.about"
                        defaultMessage="About Agency Accounts"
                    />
                </AgencyEyebrow>
                <p style={{ color: THEME.textSecondary, fontSize: 14.5, lineHeight: 1.6, marginTop: 0 }}>
                    <FormattedMessage
                        id="agency.settings.aboutText"
                        defaultMessage="Your agency account lets you manage multiple client organisations from a single dashboard. You can view your clients' brand equity data, manage their surveys, and optionally handle their billing."
                    />
                </p>
                <p style={{ color: THEME.textSecondary, fontSize: 14.5, lineHeight: 1.6, marginBottom: 0 }}>
                    <FormattedMessage
                        id="agency.settings.aboutText2"
                        defaultMessage="Client organisations are fully independent accounts. If the relationship ends, the client keeps all their data and can continue using BrandScience.ai on their own."
                    />
                </p>
            </Card>
        </div>
    );
};
